<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="供应商名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入供应商名称" />
      </el-form-item>
      <el-form-item label="联系人" prop="contact">
        <el-input v-model="formData.contact" placeholder="请输入联系人" />
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="formData.mobile" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="formData.address" placeholder="请输入地址" />
      </el-form-item>
      <el-form-item label="分级" prop="tier">
        <el-radio-group v-model="formData.tier">
          <el-radio
            v-for="item in ProductSupplierTierOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="item in ProductSupplierStatusOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="formData.sort" :min="0" controls-position="right" />
      </el-form-item>
      <el-form-item label="资质附件" prop="qualificationUrls">
        <UploadFile v-model="formData.qualificationUrls" :limit="10" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="formData.remark" type="textarea" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import {
  createSupplier,
  getSupplier,
  ProductSupplierStatus,
  ProductSupplierStatusOptions,
  ProductSupplierTier,
  ProductSupplierTierOptions,
  updateSupplier,
  type SupplierVO
} from '@/api/mall/product/supplier'

defineOptions({ name: 'ProductSupplierForm' })

const { t } = useI18n()
const message = useMessage()

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<SupplierVO>({
  id: undefined,
  name: '',
  contact: '',
  mobile: '',
  address: '',
  remark: '',
  tier: ProductSupplierTier.NORMAL,
  status: ProductSupplierStatus.ENABLE,
  sort: 0,
  qualificationUrls: []
})
const formRules = reactive({
  name: [{ required: true, message: '供应商名称不能为空', trigger: 'blur' }],
  tier: [{ required: true, message: '分级不能为空', trigger: 'change' }],
  status: [{ required: true, message: '状态不能为空', trigger: 'change' }],
  sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
})
const formRef = ref()

const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await getSupplier(id)
      if (!formData.value.qualificationUrls) {
        formData.value.qualificationUrls = []
      }
    } finally {
      formLoading.value = false
    }
  }
}
defineExpose({ open })

const emit = defineEmits(['success'])
const submitForm = async () => {
  if (!formRef.value) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value as SupplierVO
    if (formType.value === 'create') {
      await createSupplier(data)
      message.success(t('common.createSuccess'))
    } else {
      await updateSupplier(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    name: '',
    contact: '',
    mobile: '',
    address: '',
    remark: '',
    tier: ProductSupplierTier.NORMAL,
    status: ProductSupplierStatus.ENABLE,
    sort: 0,
    qualificationUrls: []
  }
  formRef.value?.resetFields()
}
</script>
